import React, { FC } from "react";
import Image from "next/image";
import styles from "../../../../styles/components/Overviewbox.module.scss";

interface OverviewboxProps {
  title: string;
  subtitle?: string;
  description?: string;
  imageSrc: string;
  backgroundColor?: string;
  linkLabel: string;
  targetUrl?: string;
  linkClickable?: boolean;
}

const Overviewbox: FC<OverviewboxProps> = ({
  title,
  subtitle,
  description,
  imageSrc,
  backgroundColor,
  linkLabel,
  targetUrl = "#",
  linkClickable
}) => {
  return (
    <div className={`${styles.overviewbox} ${styles.fadeInUp} ${styles.hover03} ${styles.alignCenter}`}>
        {
        linkClickable === true ?
        <a href={targetUrl}>
                <div className={`${styles.imagecontainer} ${styles.loaded}`}>
        <div className={`${styles.inner}`}>
            {imageSrc && (
            <Image
                className={styles.imgResponsive}
                priority
                src={imageSrc}
                width={767}
                height={514}
                alt={title}
                style={{objectFit: "cover"}}
            />
            )}
            </div>
            </div>
            <div
            className={`${styles.bgwhite} ${styles.innerPadding} `} style={{backgroundColor: `${backgroundColor}` }}
            >
            <h2 className={styles.productLink}>{title} - <span className={styles.subtitle}>{subtitle}</span></h2>
            <hr className={styles.animatedLine} />
            <p className={styles.serviceDescription}>{description}</p>
            </div>
      </a>
      :
     
       <a>
      <div className={`${styles.imagecontainer} ${styles.loaded}`}>
        <div className={`${styles.inner}`}>
            {imageSrc && (
            <Image
                className={styles.imgResponsive}
                priority
                src={imageSrc}
                width={767}
                height={514}
                alt={title}
                style={{objectFit: "cover"}}
            />
            )}
            </div>
            </div>
            <div
            className={`${styles.bgwhite} ${styles.innerPadding} `} style={{backgroundColor: `${backgroundColor}` }}     
            >
            <h2 className={styles.productLink}>{title} - <span className={styles.subtitle}>{subtitle}</span></h2>
            <hr className={styles.animatedLine} />
            <p className={styles.serviceDescription}>{description}</p>
            </div>
            </a>
     
        }
    
    </div>
  );
};

export default Overviewbox;
